import React, { useEffect, useCallback, useState } from 'react';
import Modal, { ModalTransition, ModalBody, ModalHeader } from '@atlaskit/modal-dialog';
import { observer } from 'mobx-react';
import Button from '@atlaskit/button/new';
import { Link } from 'react-router-dom';
import If from './If';
import { useStore } from '../store';
import Request from '../service/request';
import Spinner from '@atlaskit/spinner';
import ToolTip from '@atlaskit/tooltip';
import AiService from '../service/aiService';


const PromptsModal = observer(({ onClose, model, type }) => {
    const { jira } = useStore();
    const [aiEnabled, setAiEnabled] = useState(false);
    const [loading, setLoading] = useState(true);
    const aiService = new AiService();
    const suitePrompts = aiService.suitePrompts();
    const testPrompts = aiService.testPrompts(model);

    const checkAiEnabled = useCallback(async () => {
        const request = new Request(jira.testomatioToken);
        try {
            const res = await request.send(`/api/projects/${jira.testomatioProject.slug}`, { method: 'GET' });
            setAiEnabled(res.data?.attributes?.['company-settings']?.ai_enabled);
            setLoading(false);
        } catch (e) {
            //
        } finally {
            setLoading(false);
        }
    }, [jira.testomatioToken, jira.testomatioProject.slug]);

    useEffect(() => {
        checkAiEnabled();
    }, [checkAiEnabled]);

    return (
        <>
            <ModalTransition>
                <Modal
                    onClose={onClose}
                    scrollBehavior="inside"
                    height='y-large'
                    width="x-large"
                >
                    <ModalHeader>
                        <If condition={!loading && aiEnabled}>
                            <span className="text-lg font-bold">Choose Prompt</span>
                        </If>
                    </ModalHeader>
                    <ModalBody>
                    <If condition={!loading}>
                        <If condition={aiEnabled}>
                            <ul className="flex flex-col gap-4 w-full pb-2">
                                <If condition={type === 'suite'}>
                                    {suitePrompts.map((prompt) => (
                                        <div key={prompt.label} className="flex gap-4 items-center rounded-lg border border-gray-200 p-4 w-full">
                                            <div className="flex-1">
                                                <span className="font-bold">{prompt.label}</span>
                                                <p>{prompt.description}</p>
                                            </div>
                                            
                                            <Link to={`/prompts/${type}/${model.id}/${prompt.prompt}`}>
                                                <Button appearance="primary">
                                                    Run
                                                </Button>
                                            </Link>
                                        </div>
                                    ))}
                                </If>
                                <If condition={type === 'test'}>
                                    {testPrompts.map((prompt) => (
                                        <div key={prompt.label} className="flex gap-4 items-center rounded-lg border border-gray-200 p-4 w-full">
                                            <div className="flex-1">
                                                <span className="font-bold">{prompt.label}</span>
                                                <p>{prompt.description}</p>
                                            </div>
                                            <If condition={prompt.when()}>
                                                <Link to={`/prompts/${type}/${model.id}/${prompt.prompt}`} >
                                                    <Button appearance="primary">
                                                        Run
                                                    </Button>
                                                </Link>
                                            </If>
                                            <If condition={!prompt.when()}>
                                                <ToolTip content={prompt.tooltip} >
                                                    <Button appearance="primary" isDisabled>
                                                        Run
                                                    </Button>
                                                </ToolTip>
                                            </If>
                                        </div>
                                    ))}
                                </If>
                            </ul>
                        </If>
                        <If condition={!aiEnabled}>
                            <div className="flex justify-center my-12">
                                <p>AI is not enabled for this project. Please contact your administrator.</p>
                            </div>
                        </If>
                        </If>
                        <If condition={loading}>
                            <div className="flex justify-center my-12">
                                <Spinner size="large" />
                            </div>
                        </If>
                    </ModalBody>
                </Modal>
            </ModalTransition>
        </>

    );
});

export default PromptsModal;